import React from 'react';

const logo = (props) => {
    return <img src={props.url} alt=""/>
};

export default logo;


// WEBPACK FOOTER //
// ./src/customModules/Common/components/Logo.js